import cn from "../../lib/classnames";
import RadioInput from "../RadioInput";
import React from "react";
import styles from "./RadioGroup.module.css";
import {Column, Row} from "../grid";

export type RadioOption = {
    value: number;
    label: string;
    extraInfo?: string;
};

type Props = {
    radioInputs: RadioOption[];
    setValue: (n: number) => void;
    selectedValue: number;
    columnClassName?: string;
    loading?: boolean;
    isVertical?: boolean;
};

export default function RadioGroup(props: Props) {
    function renderRadioInputs(radioInputs: RadioOption[]) {
        const isEven = radioInputs.length % 2 === 0;
        let radioInputsToRender = radioInputs.slice(0, radioInputs.length);

        if (!isEven && radioInputsToRender.length > 2) {
            radioInputsToRender = radioInputs.slice(0, radioInputs.length - 1);
        }

        const partneredRadioInputs: Array<Array<RadioOption>> = [];
        if (radioInputsToRender.length >= 2) {
            for (let i = 0; i < radioInputsToRender.length; i += 2) {
                partneredRadioInputs.push([radioInputsToRender[i], radioInputsToRender[i + 1]]);
            }
        }

        let keyCounts = 0;

        return (
            <>
                {partneredRadioInputs.map((duoRadioInputs) => {
                    keyCounts += 2;
                    return (
                        <Row key={keyCounts}>
                            <Column
                                key={keyCounts - 1}
                                largeOffset={1}
                                large={10}
                                mediumOffset={1}
                                medium={6}
                                className={cn(
                                    props.columnClassName,
                                    props.isVertical ? styles.verticalColumn : undefined,
                                )}
                            >
                                <div
                                    className={cn(
                                        styles.container,
                                        props.isVertical ? styles.verticalContainer : undefined,
                                    )}
                                >
                                    <RadioInput
                                        value={duoRadioInputs[0].value}
                                        label={duoRadioInputs[0].label}
                                        setValue={props.setValue}
                                        selectedValue={props.selectedValue}
                                        className={cn(
                                            styles.radioInput,
                                            styles.doubleRadioInput,
                                            props.isVertical
                                                ? styles.verticalRadioInput
                                                : undefined,
                                            styles.radioInputLeft,
                                        )}
                                        loading={props.loading}
                                        extraInfo={duoRadioInputs[0].extraInfo}
                                    />
                                    <RadioInput
                                        value={duoRadioInputs[1].value}
                                        label={duoRadioInputs[1].label}
                                        setValue={props.setValue}
                                        selectedValue={props.selectedValue}
                                        className={cn(
                                            styles.radioInput,
                                            styles.doubleRadioInput,
                                            props.isVertical
                                                ? styles.verticalRadioInput
                                                : undefined,
                                            styles.radioInputRight,
                                        )}
                                        loading={props.loading}
                                        extraInfo={duoRadioInputs[1].extraInfo}
                                    />
                                </div>
                            </Column>
                        </Row>
                    );
                })}
                {!isEven && radioInputs.length > 0 ? (
                    <Row>
                        <Column
                            large={10}
                            largeOffset={1}
                            mediumOffset={1}
                            medium={6}
                            className={props.columnClassName}
                        >
                            <RadioInput
                                className={styles.radioInput}
                                value={radioInputs[radioInputs.length - 1].value}
                                label={radioInputs[radioInputs.length - 1].label}
                                setValue={props.setValue}
                                selectedValue={props.selectedValue}
                                loading={props.loading}
                                extraInfo={radioInputs[radioInputs.length - 1].extraInfo}
                            />
                        </Column>
                    </Row>
                ) : null}
            </>
        );
    }

    return renderRadioInputs(props.radioInputs);
}
